function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpertentelefonAvacon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,7.01765,6.99967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.184,26.546L26.292,19.653L21.365,24.58C20.844,25.101 20.087,25.188 19.675,24.776L11.624,16.727C11.212,16.312 11.301,15.556 11.821,15.036L16.747,10.108L10.387,3.749L6.788,7.348C3.131,11.005 3.214,16.792 6.87,20.45L15.849,29.43C19.505,33.086 25.39,33.265 29.049,29.606L30.289,28.432",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "1.56px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpertentelefonAvacon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expertentelefon_avacon.af7fe09c.svg";
export { ForwardRef as ReactComponent };